"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDivider = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

var _text = require("../../../styles/2_commonComponentStyles/text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledDivider = _styledComponents.default.hr.withConfig({
  displayName: "Dividerstyles__StyledDivider",
  componentId: "sc-11p8y9d-0"
})(["border:none;background-color:", ";height:2px;margin:", " 0;width:100%;@media only screen and (min-width:", "){width:31.25rem;margin:", " auto;}&.c-divider-full{width:100vw;position:relative;margin-left:-50vw;height:1px;left:50%;}"], function (props) {
  return (0, _text.getForegroundColor)(props);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', '2', props.theme.standardPadding);
}, function (props) {
  return props.theme.mediumBreak;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', '2', props.theme.standardPadding);
});

exports.StyledDivider = StyledDivider;